import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled(Flex)`
  padding: 16px;
  flex: 1 0 0;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  min-height: 710px;
  max-height: 710px;
  height: 100%;
`;

export const TitleWrapper = styled.span`
  font-size: 16px;
  font-weight: 600;
  line-height: 24px;
  letter-spacing: -0.2px;
`;

export const ItemWrapper = styled.span`
  font-size: 12px;
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black7};
`;

export const ChildrenWrapper = styled.div`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  overflow-x: auto;
`;

export const ContentWrapper = styled(Flex)`
  overflow-y: auto;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;
